import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { formElements, ValidationError, InlineWarning, ModalWindow, SaveButton } from '../../common';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as intakeFormConstants from './intake-form-constants';
import * as modifyIntakeActions from './modify-intake-form.actions';
import { IntakeFormValidation, validationConstants } from '../validate-intake-form';
import { RadioElement } from '../../common/form-elements';
import { List } from 'immutable';
import './modify-about.scss';


export class ModifyAboutComponent extends Component {
  constructor(props){
    super(props);

    this.state = {
        duplicateCheckModalShown: false,
        duplicateCheckOption: "specific"
    }
  }
  componentDidMount() {
    const { modifyIntakeActions } = this.props;
    const { updatePreviewTabRedirect } = modifyIntakeActions || {};
    // this is the landing page for edit/create intake form, so there is no extra info needed
    updatePreviewTabRedirect('');
  }

  componentDidUpdate(prevProps) {
    const { modifyIntakeActions } = this.props;
    const { updatePreviewTabRedirect } = modifyIntakeActions || {};
    // this is the landing page for edit/create intake form, so there is no extra info needed
    updatePreviewTabRedirect('');
  }

  /**
   * sets duplicate check modal shown to true. this is called whenever the modal is shown
   */
  onDuplicateCheckButtonClicked() {
    this.setState({ duplicateCheckModalShown: true });
  }

  /**
   * sets duplicate check modal shown to false. this is called whenever the modal is dismissed
   */
  onDismissDuplicateCheckDialog() {
    this.setState({ duplicateCheckModalShown: false }); 
  }

  /** 
   * handles selection change of the modal window containing duplicate check options
   * @param {string} value string of either 'specific' or 'generic'
   */
  handleSelectionChange(value) {
    const { modifyIntakeActions } = this.props;
    const option = !!value && value.size > 0 ? value.get(0) : undefined;
  
    modifyIntakeActions.setSelectedSaveOption(option);  
  }

  /** 
   * handles save of the modal window containing duplicate check options
   * gets the value of the selected radio button and updates duplicate check notification type
   * on the intake form
   */
  handleSave() {
    const { modifyIntake, modifyIntakeActions, match } = this.props;
   
    const { params } = match || {};
    const { id } = params || {};

    const { updateDupeCheckNotification } = modifyIntakeActions;

    const{ radioButtonValue } = modifyIntake || {};
    const notification  = radioButtonValue || {};

    updateDupeCheckNotification(id, notification );
    this.onDismissDuplicateCheckDialog();
  }

  getValue(section) {
    const { value } = this.props;
    return value && value.get(section);
  }

  getDefaultValue(section) {
    const { defaultValue } =this.props;
    return defaultValue && defaultValue.get(section);
  }

  getErrors(section) {
    const { errors } =this.props;
    return errors && errors.filter(val => val.sourceId === section);
  }

  render() {
    const { updateValue, disabled, showErrors, errors, intakeValidationResult, validationMessage, loadingValidation, modifyIntake } =this.props;
   

    var name = this.getValue(intakeFormConstants.nameSection);
    var defaultName = this.getDefaultValue(intakeFormConstants.nameSection);

    var title = this.getValue(intakeFormConstants.titleSection);
    var defaultTitle = this.getDefaultValue(intakeFormConstants.titleSection);

    var description = this.getValue(intakeFormConstants.descriptionSection);
    var defaultDescription = this.getDefaultValue(intakeFormConstants.descriptionSection);

    var securityDisabled = this.getValue(intakeFormConstants.securitySection);
    var defaultSecurityDisabled = this.getDefaultValue(intakeFormConstants.securitySection);
    // The opposite is being evaluated here so that the variable defaults to false, but the checkbox is supposed to default to true
    var securityEnabled = securityDisabled !== undefined ? !securityDisabled :
     defaultSecurityDisabled !== undefined ? !defaultSecurityDisabled : true;
    var securityWarning = "Disabling reCAPTCHA may leave you vulnerable to spam.";

    var numErrors = !!errors ? errors.length : 0;
    var validationDisplay = showErrors ? (
      <ValidationError
        isValid={numErrors === 0}
        errors={errors}
        errorsTitle={numErrors > 1 ? 'The following on the About tab are required:' : null}
        getErrorText={(error) => numErrors > 1 ? error.context : error.errorMessage}/>
    ) : null;

    const duplicateCheckOptions = List([
      { id: 0, value: 'specific', label: 'Show Duplicate Error (Default)', detail:'"Participant already registered with this organization."' },
      { id: 1, value: 'generic', label: 'Show Generic Error', detail: '"Uh oh. There was a problem. We weren\'t able to save your intake information. Please try again later."' }
    ]);

    return (
      <div>
        <h2>About the Form</h2>
        <IntakeFormValidation
          validationResult={intakeValidationResult}
          excludedSections={[
            validationConstants.demographicsSection,
            validationConstants.touchpointSection,
            validationConstants.loadingSection,
          ]}
          titleMessage={validationMessage}
          hideSectionHeaders={true}
          isLoading={loadingValidation}/>
        <p>Name your intake form, give it a title, then provide any instructions you think your applicants will need.</p>
        {validationDisplay}
        <formElements.SimpleTextElement
          id='name-edit'
          maxLength={50}
          response={name}
          defaultValue={defaultName}
          onChange={val => updateValue([intakeFormConstants.nameSection], val)}
          label={"Form Name"}
          isRequired={true}
          disabled={disabled}
          errors={this.getErrors(intakeFormConstants.nameSection)}
          showErrors={showErrors}/>
        <formElements.SimpleTextElement
          id='title-edit'
          maxLength={50}
          response={title}
          defaultValue={defaultTitle}
          onChange={val => updateValue([intakeFormConstants.titleSection], val)}
          label={"Title"}
          isRequired={true}
          disabled={disabled}
          errors={this.getErrors(intakeFormConstants.titleSection)}
          showErrors={showErrors}/>
        <formElements.TextElement
          id='description-edit'
          maxLength={1000}
          response={description}
          defaultValue={defaultDescription}
          onChange={val => updateValue([intakeFormConstants.descriptionSection], val)}
          label={"Description/Instructions"}
          disabled={disabled}
          errors={this.getErrors(intakeFormConstants.descriptionSection)}
          showErrors={showErrors}/>
          <ModalWindow
            show={this.state.duplicateCheckModalShown}
            title={"Please select what your participants will see when a duplicate error occurs upon Intake form submission"}
            onClose={() => this.onDismissDuplicateCheckDialog()}
            footer={
              <div>
                <button id="duplicate-check" className="btn" type="button" onClick={e => this.onDismissDuplicateCheckDialog()}> Cancel </button>
                <SaveButton
                  id="save"
                  saving={false}
                  savingText="Saving..."
                  onSave={() => this.handleSave()}/>
              </div>
            }
            contentId="duplicate-check-modal-content"
            css={{title:'dupe-title'}}
          >
            <div className="duplicate-check-radio">
              <RadioElement
                isRequired={false}
                options={duplicateCheckOptions}
                disabled={false}
                defaultValue={List([(modifyIntake || {}).radioButtonValue || 'specific'])}
                onChange={(value) => this.handleSelectionChange(value)}
                css={{   radioButton: 'dupe-list', buttonDetail: 'dupe-detail', label: "dupe-label"}}
              />
            </div>
          </ModalWindow>
          <button id="duplicate-check" className="btn btn-primary" type="button" onClick={e => this.onDuplicateCheckButtonClicked()}> Error Options </button>
        <h2>Security</h2>
        <p>By default, intake forms require applicants to complete a Google reCAPTCHA before entering and submitting their data.</p>
        <p>
          <label className='standard-text' htmlFor={'security-option'}>
            <input
              id='security-option'
              type="checkbox"
              // NOTE: the opposite value should be stored on update
              onChange={e => updateValue([intakeFormConstants.securitySection], !e.target.checked)}
              checked={securityEnabled}
              disabled={disabled} />
            Require reCAPTCHA
          </label>
        </p>
        <InlineWarning warn={securityEnabled ? null : securityWarning}/>
      </div>
    );
  }
}

ModifyAboutComponent.propTypes = {
  value : PropTypes.object,
  defaultValue : PropTypes.object,

  intakeValidationResult : PropTypes.object,
  validationMessage : PropTypes.string,
  loadingValidation : PropTypes.bool,
  validationErr : PropTypes.object,

  updateValue : PropTypes.func,
  disabled : PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool,
  modifyIntakeActions : PropTypes.any,
};

const mapStateToProps = ({ intake, modifyIntake }) => {
  return {
    intake,
    modifyIntake
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModifyAboutComponent);
